import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { isEmpty } from 'ramda';

import {
  openTableSuccessAction,
  changeGameStateAction,
  saveGameDataToStore,
  changeGameStatusAction,
  setIsShuffleRequiredAction,
} from 'data/reducers';
import { Notifications, TableOpenedResponse, TableStates } from 'types';
import { gameStatus } from 'constants/common';
import { GameType } from 'types/tables';

export function* tableOpened({ type: responseType, data }: TableOpenedResponse) {
  try {
    if (responseType === Notifications.GAME_OPENED) {
      yield put(changeGameStateAction({ tableState: TableStates.TableOpened }));
      yield put(changeGameStatusAction({ status: gameStatus.OpenRound }));
      yield put(openTableSuccessAction());

      if (data.configuration && !isEmpty(data.configuration)) {
        yield put(saveGameDataToStore({ selectedTableData: data.configuration }));
        if (data.configuration.game_type === GameType.ROULETTE) {
          yield put(changeGameStatusAction({ status: gameStatus.Loading }));
        }
        if (data.configuration.game_type === GameType.CLASSIC_BAC) {
          yield put(setIsShuffleRequiredAction(true));
        }
      }
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
